module.exports = __webpack_public_path__ + "media/public/img/background_header-246b4128dd84cd93d83777db2539f88c.png";